import Section from "@/components/ui/section";
import React from "react";
import Card from "@/components/ui/card";
import { teamData } from "@/components/data/team-data";
export default function Team() {
  return (
    <Section>
      <div className="grid grid-rows-auto lg:grid-cols-5 md:grid-cols-3 grid-cols-2 md:gap-8 gap-4">
        {teamData?.map((member, key) => (
          <Card data={member} key={"title" + key} />
        ))}
      </div>
    </Section>
  );
}
